import { z } from 'zod';
/**
 * Solicitud de reapertura de un expediente cerrado para una respuesta complementaria (la respuesta no cubrió todo lo
 * pedido). La pide el responsable del caso, que no puede reabrir; la decide quien aprueba en su área (o el líder) o la
 * cadena de mando. Al aprobarse, el expediente se reabre en el paso de responder con el plazo de la petición original.
 */
export const ReopenRequestStatus = { PENDING: 'PENDING', APPROVED: 'APPROVED', REJECTED: 'REJECTED', CANCELLED: 'CANCELLED' };
export const createReopenRequestSchema = z.object({
    reason: z.string().trim().min(10, 'Explica qué faltó responder (al menos 10 caracteres)').max(1000),
});
/** Rechazar pide el motivo (llega a quien la pidió); aprobar, no. */
export const decideReopenRequestSchema = z.object({
    approve: z.boolean(),
    comment: z.string().trim().max(2000).optional(),
}).refine((v) => v.approve || (v.comment?.length ?? 0) >= 3, { message: 'Escribe por qué se rechaza', path: ['comment'] });
export const cancelReopenRequestSchema = z.object({ reason: z.string().trim().min(3, 'Escribe el motivo').max(500) });
//# sourceMappingURL=reopen-request.js.map